<app-header-one [sticky]="true"></app-header-one>

<section class="section-b-space">
    <div class="container">
        <div class="checkout-page">
            <div class="checkout-form">
                <div class="row d-flex">
                    <div class="row d-flex">
                        <div class="text-end">
                            <button (click)="payNow()" class="btn-solid btn">PAY
                                NOW</button>
                        </div>
                    </div>

                    <div class="row d-flex">
                        <div class="col-lg-6 col-sm-6 equal-height">

                            <div class="checkout-details">
                                <div class="product-description">
                                    <div class="card">

                                        <div class="card-header">
                                            <h3 class="product-header">{{ rowDetails?.plan_title }}</h3>
                                        </div>
                                        <div class="card-body">
                                            <!-- <p class="plan-title"><strong>{{ rowDetails?.plan_title }}</strong></p> -->
                                            <!-- <p class="plan-description">{{ rowDetails?.plan_description }}</p> -->
                                            <p class="plan-title">{{ rowDetails?.plan_description }}</p>
                                            <!-- <p class="plan-title">{{rowDetails?.plan_days}}</p> -->
                                        </div>
                                        <div class="card-sub-body">
                                            <ul>
                                                <li *ngFor="let plan of rowDetails?.plans">
                                                    {{ plan.description }}
                                                </li>
                                                <li>
                                                    <p>Duration <strong>{{
                                                            rowDetails?.plan_days}}</strong>&nbsp;days</p>
                                                </li>
                                                <li>View upto <strong>{{rowDetails.max_profile_views}}</strong>
                                                    profiles </li>
                                                <li>Contact upto <strong>{{rowDetails.max_contacts}}</strong> profiles
                                                </li>
                                                <!-- <li>Daily Views upto <strong>{{plan.daily_view_limit}}</strong> profiles </li> -->
                                                <li>Express interests upto
                                                    <strong>{{rowDetails.max_profile_interests}}</strong> profiles
                                                </li>
                                                <li>Shortlist upto
                                                    <strong>{{rowDetails.max_profile_shortlists}}</strong> profiles
                                                </li>

                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-sm-6 equal-height">
                            <div class="checkout-details">
                                <span *ngIf="paymentFailedStatus" style="color: #BF0000;"
                                    [innerHTML]="paymentFailedMsg"></span>
                                <div class="order-box">
                                    <div class="title-box">
                                        <div>Product Total</div>
                                    </div>
                                    <ul class="qty">
                                        <li>Plan Price <span>{{ rowDetails?.plan_price | currency:'INR' }}</span>
                                        </li>
                                        <li>
                                            <span *ngIf="rowDetails.discount_type==='NA'">Discount</span>
                                            <span *ngIf="rowDetails.discount_type==='P'">Discount <sub
                                                    *ngIf="rowDetails?.offer_discount_percentage > 0"
                                                    style="color: #BF0000;">({{rowDetails.offer_discount_percentage}}%)</sub></span>
                                            <span *ngIf="rowDetails.discount_type==='F'">Discount Flat <sub
                                                    *ngIf="rowDetails?.offer_discount_flat > 0"
                                                    style="color: #BF0000;">({{rowDetails.offer_discount_flat |
                                                    currency:'INR'}})</sub></span>

                                            <span
                                                *ngIf="rowDetails.discount_type === 'P' || rowDetails.discount_type === 'NA'">{{
                                                rowDetails.discount_price}}</span>
                                            <span *ngIf="rowDetails.discount_type==='F'">{{
                                                rowDetails.discount_price |
                                                currency:'INR' }}</span>
                                        </li>
                                        <li>Sub Total <span>{{ rowDetails.sub_total | currency:'INR' }}</span></li>
                                        <li>GST <span>{{ rowDetails.gst_total | number:'1.2-2'}}%</span></li>
                                    </ul>
                                    <ul class="total">
                                        <li>Total Payable <span>{{ rowDetails?.total_payable |
                                                currency:'INR':'symbol':'1.2-2'}}</span></li>
                                    </ul>

                                    <div class="row">
                                        <div class="col-lg-12">&nbsp;</div>
                                    </div>


                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-footer-one></app-footer-one>